export default __webpack_public_path__ + "static/media/character_08.e49f7e6b.png";